// extracted by mini-css-extract-plugin
export default {"container":"_1lwcLBl05-D2jLubuRgxYQ==","list":"l6+afFCuurKA8Bc0-tGNGg==","title":"eymcb2n1arOWoTkhPaoxcA==","list-item":"o57s60OWI7MBr1btc5hSmw=="};